import axiosClient from 'utils/axiosClient';
import api from 'api';
import {formData} from 'utils/helpers/formData';

const getScores = async (params?: any) => {
	const response = await axiosClient.get(api.RATING.SCORES.GET_SCORES, {params});
	return response.data;
};

const getScoreReasons = async () => {
	const response = await axiosClient.get(api.RATING.SCORES.SCORE_REASONS);
	return response.data;
};

const getStudentBalance = async (studentID: number) => {
	const response = await axiosClient.get(api.RATING.SCORES.SCORE_STUDENTS_BALANCE + studentID);
	return response.data;
};

const getStudentGPA = async (studentID: number) => {
	const response = await axiosClient.get(api.RATING.SCORES.SCORE_STUDENTS_GPA + studentID);
	return response.data;
};

const triggerYearlyBonuses = async () => {
	const response = await axiosClient.post(api.RATING.SCORES.TRIGGER_AUTO_YEARLY_BONUSES);
	return response.data;
};

const getScoreByID = async (id: number) => {
	const response = await axiosClient.get(api.RATING.SCORES.GET_SCORES + `/` + id);
	return response.data;
};

const createScore = async (data: any) => {
	const response = await axiosClient.post(api.RATING.SCORES.GET_SCORES, formData(data));
	return response.data;
};

const deleteScore = async (id: number) => {
	const response = await axiosClient.delete(api.RATING.SCORES.GET_SCORES + `/` + id);
	return response.data;
};

const approveScore = async (id: number) => {
	const response = await axiosClient.patch(api.RATING.SCORES.GET_SCORES + `/` + id + `/approve`);
	return response.data;
};

const rejectScore = async (id: number, rejectReason?: string) => {
	const response = await axiosClient.patch(
		api.RATING.SCORES.GET_SCORES + `/` + id + `/reject`,
		rejectReason ? {rejectReason} : undefined
	);
	return response.data;
};

const service = {
	getScores,
	getScoreReasons,
	getStudentBalance,
	getStudentGPA,
	triggerYearlyBonuses,
	getScoreByID,
	createScore,
	deleteScore,
	approveScore,
	rejectScore
};

export default service;
